import React from 'react';

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const ChartCard = ({ title, children, className = '' }: ChartCardProps) => {
  return (
    <div className={`rounded-xl border bg-gradient-to-b from-white to-gray-50 p-8 ${className}`}>
      <div className="flex items-baseline justify-between">
        <p className="flex flex-row items-center gap-1 font-medium text-gray-800">{title}</p>
      </div>
      {children}
    </div>
  );
};

export default ChartCard;
